module.exports = {
    remoteConfig: require( "./remote/remote.actual.js" ),
};



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 334
// module chunks = 0